// These are default colors if no color is provided
// colors are made based on the index of the item in the array

export const defaultColors = [
  "rgba(239, 68, 68, 0.8)", // red-300
  "rgba(249, 115, 22, 0.8)", // orange-300
  "rgba(245, 158, 11, 0.8)", // amber-300
  "rgba(234, 179, 8, 0.8)", // yellow-300
  "rgba(132, 204, 22, 0.8)", // lime-300
  "rgba(34, 197, 94, 0.8)", // green-300
  "rgba(16, 185, 129, 0.8)", // emerald-300
  "rgba(20, 184, 166, 0.8)", // teal-300
  "rgba(6, 182, 212, 0.8)", // cyan-300
  "rgba(14, 165, 233, 0.8)", // sky-300
  "rgba(59, 130, 246, 0.8)", // blue-300
  "rgba(99, 102, 241, 0.8)", // indigo-300
  "rgba(139, 92, 246, 0.8)", // violet-300
  "rgba(168, 85, 247, 0.8)", // purple-300
  "rgba(217, 70, 239, 0.8)", // fuchsia-300
  "rgba(236, 72, 153, 0.8)", // pink-300
  "rgba(249, 168, 212, 0.8)", // rose-300
  "rgba(161, 161, 170, 0.8)", // zinc-300
]
